import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
    NON_INPUT_X_AFFORDANCE_DESKTOP,
    NON_INPUT_X_AFFORDANCE_MOBILE,
} from '../../../picker-constants';

import { breakpoint } from '../../../grid';
import { FontFamily } from '../../../typography';
import { white, blueLink, pink25, grey25, navy } from '@zocdoc/branding/colors';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { MetricsClickable } from '@zocdoc/frontend-metrics';

class BaseInsuranceChangeView extends Component {
    render() {
        const {
            clearCarrierAndPlan,
            confirmSelection,
        } = this.props;

        return (
            <StyledCssTransitionGroup
                transitionAppear
                transitionAppearTimeout={250}
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}
                transitionName={transitionName}
            >
                <ChangeState data-test="change-state">
                    <ol>
                        <ChangeItem
                            data-test="selected-insurance-change-state"
                            onClick={() => confirmSelection(this.props)}
                            onTouchStart={() => { }}
                        >
                            {this.getSelectionName()}
                        </ChangeItem>
                        <ChangeSeparator data-test="section-separator" />
                        <MetricsClickable
                            action="Clicked Change"
                            element="ChooseDifferentLink"
                        >
                            <ChangeLink
                                data-test="change-link"
                                onClick={() => clearCarrierAndPlan()}
                                onTouchStart={() => { }}
                            >
                                <FormattedMessage
                                    defaultMessage="choose a different insurance"
                                    id="Components.InsurancePicker.ChooseLink"
                                />
                            </ChangeLink>
                        </MetricsClickable>
                    </ol>
                </ChangeState>
            </StyledCssTransitionGroup>
        );
    }

    getSelectionName() {
        const {
            carrierName,
            planName,
        } = this.props;

        let name = carrierName;

        if (planName) {
            name += ` - ${planName}`;
        }

        return name;
    }
}

const transitionName = {
    appear: 'change-appear',
    appearActive: 'change-appear-active',
};

const StyledCssTransitionGroup = styled(CSSTransitionGroup)`
    .change-appear {
        opacity: 0.3;

        ${breakpoint('small')} {
            top: -50px;
            position: absolute;
        }
    }
    .change-appear.change-appear-active {
        opacity: 1;
        transition: opacity 0.3s ease-in;

        ${breakpoint('small')} {
            top: 0;
            transition: top 0.25s ease-in;
        }
    }
`;

const ChangeState = styled.div`
    width: 100%;

    ${breakpoint.small} {
        padding: 12px 0 0;
        min-height: 100px;
        background: ${white};
    }
`;

const ChangeItem = styled.li`
    width: inherit;
    font: 13px/24px ${FontFamily.SharpSansSemibold};
    box-sizing: inherit;
    padding: 4px 20px;
    position: relative;
    list-style: none;
    text-size-adjust: none;
    color: ${navy};

    &:active {
        cursor: pointer;
        background-color: ${pink25};
        -webkit-tap-highlight-color: ${pink25};
    }

    ${breakpoint.small} {
        padding-left: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
        padding-right: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;

        &:hover {
            cursor: pointer;
            background-color: ${pink25};
        }
    }
`;

const ChangeSeparator = styled.li`
    margin: 8px ${NON_INPUT_X_AFFORDANCE_MOBILE}px;
    border-top: 1px solid ${grey25};

    ${breakpoint.small} {
        margin-left: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
        margin-right: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
    }
`;

const ChangeLink = styled.li`
    font: 13px/24px ${FontFamily.SharpSansSemibold};
    color: ${blueLink};
    padding: 4px ${NON_INPUT_X_AFFORDANCE_MOBILE}px;
    margin-bottom: 8px;

    ${breakpoint('medium')} {
        font: 15px/24px ${FontFamily.SharpSansSemibold};
    }

    &:hover {
        cursor: pointer;
        text-decoration: underline;
    }

    ${breakpoint.small} {
        padding-left: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
        padding-right: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
    }
`;

export const InsuranceChangeView = injectIntl(BaseInsuranceChangeView);
